import React from 'react';
import _ from 'lodash';
import { Link, withPrefix } from 'gatsby';
import slugify from 'slugify';
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';
import { TableData, TableRow } from '~components/common/Table';
import { rowRendererProps } from '../propTypes';
import { RowDataRenderer } from './default';

export default function PAVRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());
  const stateData = _.keyBy(state.nodes, 'field_type');

  let pavType;
  const statePAV = stateData.absentee_access_levels.text;
  const elderlyPAV = stateData.has_pav_elderly.bool_value;
  const disabledPAV = stateData.has_pav_disabled.bool_value;
  const requestDuration = stateData.absentee_access_levels.footnotes;

  if (statePAV === 'universal') {
    pavType = `Universal`;
  } else if (statePAV === 'permanent') {
    pavType = `Permanent`;
  } else if (statePAV === 'semi_permanent') {
    pavType = `Semi-permanent`;
  } else if (statePAV === 'no_excuse') {
    pavType = `No-excuse`;
  } else {
    pavType = `Excuse required`;
  }

  const requestLink =
    statePAV === 'permanent'
      ? withPrefix('/pav/')
      : withPrefix(`/absentee-mail-ballot/${stateSlug}/`);
  const requestLinkText =
    statePAV === 'permanent'
      ? `Sign up for permanent absentee voting in ${stateName}`
      : `Request your ${stateName} absentee or mail ballot`;

  configureAnchors({ offset: -75, scrollDuration: 300 });

  return (
    <TableRow>
      <TableData>
        <ScrollableAnchor id={stateSlug}>
          <a
            href={`/how-to-vote/${stateSlug}/`}
            title={`How to vote in ${stateName}`}
          >
            {stateName}
          </a>
        </ScrollableAnchor>
      </TableData>
      <RowDataRenderer
        columns={[
          {
            title: 'Absentee Access level',
            valueNode: pavType,
          },
          {
            title: 'PAV disabled voters',
            valueBool: disabledPAV,
          },
          {
            title: 'PAV elderly Voters',
            valueBool: elderlyPAV,
          },
          {
            title: 'Request duration',
            valueNode: `${requestDuration}`,
          },
          {
            title: 'Submit your request',
            valueNode: (
              <Link to={requestLink} title={requestLinkText}>
                {requestLinkText}
              </Link>
            ),
          },
        ]}
      />
    </TableRow>
  );
}

PAVRowRenderer.propTypes = rowRendererProps;
